const InlineErrors = ({ validate = [], errorMessages = {}, modifier = "" }) => {
	const mainClass = "help-inline-errors";
	const modifierClass = ` ${mainClass}--${modifier}`;

	const messages = Array.isArray(validate)
		? validate.map(
				(id, index) =>
					errorMessages[id] && (
						<li role="alert" id={`${id}_error`} key={index}>
							{errorMessages[id]}
						</li>
					)
		  )
		: errorMessages[validate] && (
				<li role="alert" id={`${validate}_error`} key={validate}>
					{errorMessages[validate]}
				</li>
		  );

	if (!messages) return null;
	return (
		<ul className={`${mainClass}${modifier ? modifierClass : ""}`}>
			{messages}
		</ul>
	);
};

export default InlineErrors;
